
const SvgComponent = () => {
    const w = 24
    const h = 24
    return (
        <svg xmlns="http://www.w3.org/2000/svg" data-name="check box" width={w} height={h} viewBox="0 0 24 24" >
            <defs>
                <filter id="1g5ajx5doa">
                    <feOffset />
                    <feGaussianBlur stdDeviation="1" result="blur" />
                    <feFlood floodOpacity=".161" result="color" />
                    <feComposite operator="out" in="SourceGraphic" in2="blur" />
                    <feComposite operator="in" in="color" />
                    <feComposite operator="in" in2="SourceGraphic" />
                </filter>
            </defs>
            <g data-type="innerShadowGroup">
                <path data-name="check box" fill="#f7f7f7" d="M0 0h24v24H0z" />
                <g filter="url(#1g5ajx5doa)">
                    <path data-name="check box" fill="#fff" d="M0 0h24v24H0z" />
                </g>
            </g>
        </svg >
    )
}

export default SvgComponent
